// The custom-element bundle — everything that pulls in Mapbox GL, and nothing
// else. Rebuilt via: just build::components → static/components-map.js
//
// mapbox-gl is 489 KB gzipped and only /globe and /trips/<id>/* render a map,
// so _app.tsx loads this only where needsMap() says so. It is the sole bundle:
// custom elements are reserved for Mapbox-coupled components, and every other
// control is a Preact island.

// Silently drop Mapbox telemetry requests before they reach the network,
// preventing CSP violation noise in the console. Installed here, so it runs
// only on the pages that load Mapbox.
const _fetch = globalThis.fetch
globalThis.fetch = (input, init?) => {
  const url = typeof input === "string"
    ? input
    : input instanceof URL
    ? input.href
    : (input as Request).url
  if (url.includes("events.mapbox.com")) {
    return Promise.resolve(new Response(null, { status: 200 }))
  }
  return _fetch(input, init)
}

export * from "./trip-map.ts"
export * from "./globe-view.ts"
export * from "./controls/map-style-switcher.ts"
export * from "./controls/map-picker-control.ts"
export * from "./controls/route-animator-control.ts"
export * from "./controls/trip-navigator-control.ts"
export type { MapControl, MapControlPosition } from "./map-control.ts"
export type { MapStyle } from "./map-styles.ts"

// Custom element registration
// (Each @customElement decorator above already registers the element, but
//  we list them here for documentation and to ensure side-effect imports.)
// trip-map, globe-view, map-style-switcher, map-picker-control,
// route-animator-control, trip-navigator-control
